import {
  HTMLAttributes,
  KeyboardEvent,
  useCallback,
  useEffect,
  useState,
} from "react";
import { useParams } from "react-router-dom";
import {
  CharacterCount,
  EditableTextAreaContainer,
  StyledTextArea,
} from "./EditableTextArea.styles";
import { TextStyleVariant } from "../../core-ui/components/Text/TextUtils";

export interface EditableTextAreaProps {
  initialValue: string;
  editMode: boolean;
  placeholder: string;
  onChange?: (newValue: string) => void;
  width?: string | number;
  height?: string | number;
  characterCount?: number;
  numberOfLines?: number;
  handleSubmit?: () => void;
  containerProps?: Partial<HTMLAttributes<HTMLDivElement>>;
  spanProps?: Partial<HTMLAttributes<HTMLSpanElement>>;
  textAreaProps?: Partial<HTMLAttributes<HTMLTextAreaElement>>;
}

export const EditableTextArea = ({
  height,
  width,
  initialValue,
  editMode,
  placeholder,
  onChange = () => {},
  characterCount = 2000,
  numberOfLines,
  handleSubmit = () => {},
  containerProps = {},
  textAreaProps = {},
  spanProps = {},
}: EditableTextAreaProps) => {
  const [value, setValue] = useState<string>(initialValue);
  const { username } = useParams<{ username: string | undefined }>();

  const handleKeyDown = useCallback(
    (event: KeyboardEvent<HTMLTextAreaElement>) => {
      if (event.key === "Enter" && event.metaKey) {
        handleSubmit();
      }
    },
    [handleSubmit],
  );
  useEffect(() => {
    setValue(initialValue);
  }, [username, initialValue]);

  return (
    <EditableTextAreaContainer
      {...containerProps}
      className="editable-text-area-container"
    >
      <StyledTextArea
        rows={numberOfLines}
        maxLength={characterCount}
        style={{ height, width }}
        className="editable-text-area"
        onChange={(e) => {
          setValue(e.target.value);
          onChange(e.target.value);
        }}
        placeholder={placeholder}
        disabled={!editMode}
        value={value}
        onKeyDown={handleKeyDown}
        {...textAreaProps}
      />
      {editMode && (
        <CharacterCount
          variant={TextStyleVariant.P3}
          {...spanProps}
          className="character-count"
        >{`${value.length}/${characterCount}`}</CharacterCount>
      )}
    </EditableTextAreaContainer>
  );
};
